import { render, staticRenderFns } from "./BannerProfilePanel.vue?vue&type=template&id=a2854f80&scoped=true"
import script from "./BannerProfilePanel.vue?vue&type=script&lang=js"
export * from "./BannerProfilePanel.vue?vue&type=script&lang=js"
import style0 from "./BannerProfilePanel.vue?vue&type=style&index=0&id=a2854f80&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2854f80",
  null
  
)

export default component.exports